// ** IMPORTANT **: Keep in sync with
// /Users/afikanyati/Documents/2021/Verascope/automations/packages/shared/src/enums/platform.enum.ts
export enum SOCIAL_AUTOMATION_PLATFORM {
    instagram = 'instagram',
    threads = 'threads',
    x = 'x',
    youtube = 'youtube',
}
